import { Component } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';
import { GN } from '../../gn';
import { DIC } from '../dic';
import * as moment from 'moment';
import { ClinicopenroomPage } from '../clinicopenroom/clinicopenroom';

/**
 * Generated class for the Clinic1oldPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-clinic1old',
  templateUrl: 'clinic1old.html',
})
export class Clinic1oldPage {
  loading = false;
  allDevices = []
  allDevicesIds = []
  dataLegend = []


  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC, public modalCtrl: ModalController) {

  }

  ionViewDidLoad() {
    for (var o = 0; o < this.gn.Organisations.length; o++) {
      this.gn.Organisations[o].expand = true;
    }
    this.loadData();
  }


  loadData() {
    this.loading = false;
    this.allDevices = []
    this.allDevicesIds = []
    this.dataLegend = []
    var _that = this
    this.gn._Post('/api/gn/getcurrentbeacons', { cid: this.gn.crypt(this.gn.user.ClientId) }, function (_dataCurrent) {
      _that.gn._Post('/api/gn/getclinicrooms', { cid: _that.gn.crypt(_that.gn.user.ClientId) }, function (_data) {
        _that.dataLegend = _data.datalegend
        _data = _data.data
        for (var i = 0; i < _data.length; i++) {
          var cnt = 0;
          _that.allDevicesIds.push(_data[i].id)

          _that.allDevices[_data[i].id] = []
          _that.allDevices[_data[i].id].roomid = _data[i].id
          _that.allDevices[_data[i].id].room = _data[i].room
          _that.allDevices[_data[i].id].color = _data[i].color
          _that.allDevices[_data[i].id].colorpulse = _data[i].colorpulse
          _that.allDevices[_data[i].id].notifcolor = _data[i].notifcolor
          _that.allDevices[_data[i].id].expand = true


          for (var c = 0; c < _dataCurrent.length; c++) {
            if (_dataCurrent[c].fulldata != null) {
              var arrdata = _dataCurrent[c].fulldata.split('~')
              var roomname = arrdata[6];//.toLowerCase()//replace(" ", "")
              //if (_data[i].room.toLowerCase() == roomname.toLowerCase() || _data[i].room.toLowerCase() == roomname.replace(" ", "").toLowerCase()) {
              if (_data[i].id == _that.gn.Vehicles[_that.gn.VehiclesDic[arrdata[1]]].roomid) {
                var _enddate = '/'
                if (arrdata[3] != '/') {
                  _enddate = moment(arrdata[3]).format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat)
                } else {
                  cnt++;
                }
                _that.allDevices[_data[i].id].push({ fullname: arrdata[5], code: _dataCurrent[c].code, dt: moment(arrdata[2]).format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat), enddt: _enddate, duration: _that.sec2str3(arrdata[8]), visible: true, orgid: arrdata[7] })
              }
            }
          }
          _that.allDevices[_data[i].id].cnt = cnt;
          // if (i == 0) {
          //   _that.allDevices[_data[i].id].push({ fullname: 'Јован Томовски', code: '099', dt: moment('2020-04-12 09:32:32').format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat), duration: '11min 30sec', visible: true, orgid: _that.gn.Organisations[0].id })
          // }
          // if (i == 3) {
          //   _that.allDevices[_data[i].id].push({ fullname: 'Мирјана Спасова', code: '910', dt: moment('2020-04-12 09:39:45').format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat), duration: '11min 30sec', visible: true, orgid: _that.gn.Organisations[4].id })
          //   _that.allDevices[_data[i].id].push({ fullname: 'Марко Ивановски', code: '001', dt: moment('2020-04-12 09:30:20').format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat), duration: '11min 30sec', visible: true, orgid: _that.gn.Organisations[0].id })
          //   _that.allDevices[_data[i].id].push({ fullname: 'Иван Крстевски', code: '121', dt: moment('2020-04-12 10:37:29').format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat), duration: '11min 30sec', visible: true, orgid: _that.gn.Organisations[3].id })
          // }
          // if (i == 7) {
          //   _that.allDevices[_data[i].id].push({ fullname: 'Ненад Илиевски', code: '071', dt: moment('2020-04-12 09:39:45').format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat), duration: '11min 30sec', visible: true, orgid: _that.gn.Organisations[3].id })
          //   _that.allDevices[_data[i].id].push({ fullname: 'Теодор Петровски', code: '777', dt: moment('2020-04-12 09:39:45').format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat), duration: '11min 30sec', visible: true, orgid: _that.gn.Organisations[1].id })
          //   _that.allDevices[_data[i].id].push({ fullname: 'Александра Михајлова', code: '878', dt: moment('2020-04-12 09:39:45').format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat), duration: '11min 30sec', visible: true, orgid: _that.gn.Organisations[0].id })
          // }
          // if (i == 14) {
          //   _that.allDevices[_data[i].id].push({ fullname: 'Сања Илиева', code: '109', dt: moment('2020-04-12 10:39:45').format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat), duration: '11min 30sec', visible: true, orgid: _that.gn.Organisations[2].id })
          //   _that.allDevices[_data[i].id].push({ fullname: 'Дарко Иванов', code: '542', dt: moment('2020-04-12 11:39:45').format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat), duration: '11min 30sec', visible: true, orgid: _that.gn.Organisations[4].id })
          //   _that.allDevices[_data[i].id].push({ fullname: 'Петар Поповски', code: '956', dt: moment('2020-04-12 10:48:45').format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat), duration: '11min 30sec', visible: true, orgid: _that.gn.Organisations[1].id })
          //   _that.allDevices[_data[i].id].push({ fullname: 'Виолета Стојчевска', code: '843', dt: moment('2020-04-12 08:59:45').format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat), duration: '11min 30sec', visible: true, orgid: _that.gn.Organisations[2].id })
          // }
          // if (i == 19) {
          //   _that.allDevices[_data[i].id].push({ fullname: 'Никола Николов', code: '010', dt: moment('2020-04-12 09:33:24').format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat), duration: '11min 30sec', visible: true, orgid: _that.gn.Organisations[4].id })
          //   _that.allDevices[_data[i].id].push({ fullname: 'Ана Јовановска', code: '021', dt: moment('2020-04-12 09:37:28').format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat), duration: '11min 30sec', visible: true, orgid: _that.gn.Organisations[1].id })
          // }




          if (i == _data.length - 1) {
            document.getElementById('kikiimg').style.maxHeight = (document.getElementById('kiki').offsetHeight - 40) + 'px'

            setTimeout(() => {
              document.getElementById('kikilist').style.width = (document.getElementById('kiki').offsetWidth - document.getElementById('kikiimg').offsetWidth) + 'px'

              _that.loading = true;
              //debugger
            }, 2000);
          }
        }


      })
    })
  }

  openRoom(_did) {
    var _that = this
    let modal = this.modalCtrl.create(ClinicopenroomPage, {
      d: _that.allDevices[_did], did: _did, cb: function () {
        // _that.loadData()
      }
    },
      { cssClass: "modal-fullscreen-clinic" }
    );
    modal.present();
  }

  searchItems(_ev) {
    // var txt = _ev.target.value
    // console.log(txt)
    this.getItems(_ev)
  }

  getItems(ev: any) {
    let val = ev.target.value;
    if (val == null) { val = '' }
    val = val.toLowerCase()

    this.searchInRooms(val)
  }

  sec2str3(_sec) {
    if (_sec >= 0) {
      var str = '';
      var h = Math.floor(_sec / 3600);//moment.utc(_sec * 1000).format('H');
      var m = moment.utc(_sec * 1000).format('m');
      var s = moment.utc(_sec * 1000).format('s');
      if (_sec < 60) {
        str = s + this.dic.l["sec"];
      }
      else {
        if (_sec < 3600) {
          str = m + this.dic.l["min"] + ' ' + s + this.dic.l["sec"]
        }
        else {
          str = h + this.dic.l["h"] + ' ' + m + this.dic.l["min"]
        }
      }
      // console.log("sec2str2")  
      return str;
    }
    else {
      return -1;
    }
  }

  searchInRooms(val) {
    var val1 = this.gn._cyrlat(val)
    var val2 = this.gn._latcyr(val)

    if (val && val.trim() != '') {
      //debugger
      for (var i = 0; i < this.allDevicesIds.length; i++) {
        for (var j = 0; j < this.allDevices[this.allDevicesIds[i]].length; j++) {
          //debugger
          if (this.allDevices[this.allDevicesIds[i]][j].fullname.toLowerCase().indexOf(val1) > -1 || this.allDevices[this.allDevicesIds[i]][j].fullname.toLowerCase().indexOf(val2) > -1) {
            this.allDevices[this.allDevicesIds[i]][j].visible = true;
          } else {
            if (this.allDevices[this.allDevicesIds[i]][j].code.toLowerCase().indexOf(val1) > -1 || this.allDevices[this.allDevicesIds[i]][j].code.toLowerCase().indexOf(val2) > -1) {
              this.allDevices[this.allDevicesIds[i]][j].visible = true;
            } else {
              this.allDevices[this.allDevicesIds[i]][j].visible = false;
            }
          }
        }
      }
      // for (var i = 0; i < this.gn.Vehicles.length; i++) {
      //   if (this.gn.Vehicles[i].registration.toLowerCase().indexOf(val1) > -1 || this.gn.Vehicles[i].registration.toLowerCase().indexOf(val2) > -1) {
      //     this.gn.Vehicles[i].searchVisible = true
      //   } else {
      //  this.gn.Vehicles[i].searchVisible = false
      //}
      // }
    } else {
      this.resetSearch()
    }
  }

  resetSearch() {
    for (var i = 0; i < this.allDevicesIds.length; i++) {
      for (var j = 0; j < this.allDevices[this.allDevicesIds[i]].length; j++) {
        this.allDevices[this.allDevicesIds[i]][j].visible = true;
      }
    }
  }


}


// WEBPACK FOOTER //
// ./src/pages/clinic1old/clinic1old.ts